import { Dispatch, SetStateAction, useCallback } from 'react'
import { FirebaseDocRefType } from 'firebase/index'
import { StockUnionType } from 'types/stock'
import { getUpdateSchedulesFunction } from 'components/Templates/product/default/ProductEditDefaultTemplate'
import { StoreDefaultScheduleType } from 'types/storeDefault'

const useDeleteDefaultStock = (
  setDailySchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>
): ((scheduleRef: FirebaseDocRefType, defaultStockIndex: number, type: StockUnionType) => void) => {
  return useCallback(
    (scheduleRef: FirebaseDocRefType, defaultStockIndex: number, type: StockUnionType) => {
      const update = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!update) return
      update((prevState) => {
        const nextState = prevState
        const index = prevState.findIndex((prevState) => prevState.schedule_ref?.id === scheduleRef.id)
        nextState[index].default_stocks = prevState[index].default_stocks.filter((_, i) => i !== defaultStockIndex)
        return [...nextState]
      })
    },
    [setDailySchedules, setPreorderSchedules]
  )
}

export default useDeleteDefaultStock
